import React from 'react';
import {EmailToDataContainer} from '../../Containers/EmailContainer';


export const EmailToData = (props) => {
	return (
		<EmailToDataContainer />
	);
}

export default EmailToData;
